import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { IndexComponent } from './index.component';

import { AuthGuard } from '../auth-guard.service';

const routes: Routes = [
  {
    path: "catalogos",
    component: IndexComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "personas",
    component: IndexComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "personal",
    component: IndexComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "promocion",
    component: IndexComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "coordinacion-academica",
    component: IndexComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "control-escolar",
    component: IndexComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "servicio-financiero",
    component: IndexComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "operacion",
    component: IndexComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "inventario",
    component: IndexComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "sistema",
    component: IndexComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "configuracion",
    component: IndexComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "facturacion",
    component: IndexComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "reportes",
    component: IndexComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "eventos",
    component: IndexComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "formulario",
    component: IndexComponent,
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class IndexRoutingModule { }
